export default "__VITE_ASSET__6356b0be__$_?component__"